export const UPLOAD_GET_SIGNED_S3_UPLOAD = 'UPLOAD_GET_SIGNED_S3_UPLOAD'
export const UPLOAD_S3_MEDIA = 'UPLOAD_S3_MEDIA'
export const UPLOAD_STARTED = 'UPLOAD_STARTED'
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS'
export const UPLOAD_FINISHED = 'UPLOAD_FINISHED'
